<template>
  <section class="content">
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
      <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-12 p-md-2">
               <label >Challan Date</label>
               <date-picker ref="tran" v-model="purchaseSalesDate" valueType="format" v-if="!englishDateEnabled"/>
                <InputMask mask="9999-99-99" ref="tran" type="text" v-else class="nepali-calendar" id="purchaseSalesDate" v-model="purchaseSalesDate"/>
              </div>

              <div class="p-field p-col-12 p-md-2">
                <label for="challanNo" >Challan No</label>
                <InputText id="challanNo" disabled v-model="challanNo"/>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label for="referenceNumber">Ref No</label>
                <InputText id="referenceNumber"  v-model="referenceNumber"/>
              </div>
               <div class="p-field p-col-12 p-md-2">
                  <label for="warehouse" >Store</label>
                <Dropdown
                  v-if="!setWarehouseData"
                  v-model="warehouseId"
                  :options="warehouseLists"
                  optionLabel="name"
                  id="warehouse"
                  :filter="true"
                  placeholder="Select warehouse"
                  :showClear="true"
                />
                <Dropdown
                  v-else
                  v-model="warehouseId"
                  :options="warehouseLists"
                  optionLabel="name"
                  id="warehouse"
                  :filter="true"
                  placeholder="Select warehouse"
                  :showClear="true"
                  :disabled="true"
                />

              </div>
              <wearhouseDialog class="p-mt-5" style="margin-right: -10em;" v-tooltip.top="'Add Warehouse'" @set_data_warehouse="set_data_warehouse"/>
            </div>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
                <div class="p-field p-col-12 p-md-2">
                  <label for="party" >Challan From</label>
                  <Dropdown
                  v-model="accountMasterId"
                  :options="supplierAndCustomerList"
                  optionLabel="name"
                  :filter="true"
                  placeholder="Select Vendor"
                  :showClear="true"
                  id="party"
                />
              </div>
              <supplierDialog class="p-mt-5" v-tooltip.top="'Add Supplier'" @set_supplier_master="set_supplier_master"/>
              <div class="p-field p-col-12 p-md-2" v-if="!this.editing">
                <label for="loadFrom">Load From Order</label>
                <Dropdown
                  v-model="orderId"
                  :options="orderIdList"
                  optionLabel="orderNo"
                  :filter="true"
                  @change="loadOrderDataWithOrderId(orderId.orderNo)"
                  placeholder="Select Item"
                />
              </div>
              <div class="p-field p-col-12 p-md-2 p-mt-5" v-if="accountMasterId.id>0">
                 <label for="panNo">Closing Balance</label>
                 <b class="address" style="margin-left:20px;color:red;" v-if="accountMasterId.closingBalance>0">{{(accountMasterId.closingBalance).toFixed(2) +'Cr'}}</b>
                 <b class="address" v-else style="margin-left:20px;color:green;">{{(accountMasterId.closingBalance*(-1)).toFixed(2) +'Dr'}}</b>
              </div>
              <div class="p-field p-col-12 p-md-2 p-mt-5" v-if="accountMasterId.id>0">
                <label for="panNo">Pan No</label>
                <b id="panNo">{{accountMasterId.panNo}}</b>
              </div>
            </div>

            <div class="p-fluid p-formgrid p-grid p-mt-2">
                <div class="p-field p-col-12 p-md-2">
                  <label for="item">Item<b style="color:red;">*</b></label>
                  <AutoComplete v-model="items" filterMatchMode='contains'
                 :suggestions="filteredItems" @complete="searchItem($event)"
                  field="name" ref="itm">
                 </AutoComplete>
              </div>
               <itemDialog class="p-mt-5" style="margin-right: -10em;" v-tooltip.top="'Add Item'" @set_data_item="set_data_item"/>
              <div class="p-field p-col-12 p-md-2">
                <label  for="quantity">Quantity</label>
                <!-- <input type="text" class="form-control" @keypress="isNumber(event)" id="quantity" v-model="quantity" /> -->
              <InputNumber id="minmaxfraction" onfocus="if (this.value === '0.00')
                                this.value = ''" v-model="quantity"  :minFractionDigits="2" :maxFracionDigits="4" />
              </div>
              <div class="p-field p-col-12 p-md-1">
                <label for="qty">Unit</label>
                <InputText v-model="items.unitName" disabled/>
              </div>
              <div class="p-field p-col-12 p-md-2">
               <label  for="rate">Rate</label>
                <!-- <input type="text" class="form-control" @keypress="isNumber(event)" id="rate" v-model="rate" /> -->
              <InputNumber id="minmaxfraction" v-model="rate" onfocus="if (this.value === '0.00')
                                this.value = ''" :minFractionDigits="2" :maxFracionDigits="4" />
             </div>
              <div class="p-field p-col-12 p-md-2">
                <label  for="total" >Total</label>
                <!-- <input  class="form-control" id="total" @keypress="isNumber(event)" @ v-model="total"/> -->
              <InputNumber disabled id="minmaxfraction" v-model="total" onfocus="if (this.value === '0.00')
                                this.value = ''"  :minFractionDigits="2" :maxFracionDigits="4" />
              </div>

            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button class="p-button-raised p-button-rounded"  id="action" @click.prevent="addItemToDTO" :label="!editDto?'Add':'Update'"/>
            </div>
            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button class="p-button-raised p-button-danger" v-if="editDto" @click="itemDTOreset" label="Cancel"/>
            </div>
          </div>
          <div>
              <div style="display:none">{{totalAmount}}{{findRate}}{{setRateFromItem}}</div>
                <div class="p-field p-col-12 p-md-2" v-if="items.closingStock >=0">
                  <label for="avlQty">Cur. Qty: </label>
                  <span>{{items.closingStock}}</span>
              </div>
            </div>
        </form>
        <div class="p-field p-col-12 p-md-12">
          <div class="row">
            <div class="scrollable">
              <table class="table table-bordered ">
                <thead >
                  <tr>
                    <th >SN</th>
                    <th >Item Name</th>
                    <th >Quantity</th>
                    <th >Rate</th>
                    <th >Amount</th>
                    <th >Action</th>
                  </tr>
                </thead>
                <tbody  v-for="(item,index) in inventoryInOutDetailList " :key="index">
                  <tr>
                    <td>{{index+1}}</td>
                    <td>{{item.itemMaster.name}}</td>
                    <td>{{item.quantity}}</td>
                    <td>{{item.rate}}</td>
                    <td>{{item.rate * item.quantity}} </td>
                    <td>
                      <Button class="p-button-raised p-button-success" @click="editFromDto(item,index)" icon="pi pi-pencil"/>
                      <Button class="p-button-raised p-button-danger" v-if="editDto" @click="deleteItemFromDTO(item, index)" disabled icon="pi pi-trash"/>
                      <Button class="p-button-raised p-button-danger" v-else-if="!editDto" @click="deleteItemFromDTO(item, index)" icon="pi pi-trash"/>
                    </td>
                  </tr>
                </tbody>
             </table>
           </div>
           <hr>
           <div class="p-fluid p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-12 p-md-2">
                <b style="margin-left: 15em;">Total:</b>
              </div>
              <div class="p-field p-col-12 p-md-2">
                  <b style="margin-left: 20em;">{{totalQty}}</b>
              </div>
              <div class="p-field p-col-12 p-md-2">
                  <b style="margin-left: 38em;">{{subTotal}}</b>
              </div>
            </div>
           <hr>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
            <div class="p-field p-col-12 p-md-4">
            <label >Narration</label>
            <Textarea rows="6" v-model="narration"/>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-6"></div>
          <div class="p-field p-col-12 p-md-1">
           <Button class="p-button-raised p-button-success" @click.prevent="savePurchaseChallan"
           :label="purchaseChallan === undefined ? 'Save': 'Update'" icon="pi pi-save"/>
          </div>
            <div class="p-field p-col-12 p-md-1" v-if="purchaseChallan === undefined" >
            <Button class="p-button-raised p-button-warning" label="Reset" icon="pi pi-refresh"
             @click="reset" />
           </div>
           <div class="p-field p-col-12 p-md-1"  v-if="purchaseChallan!=undefined">
            <Button  @click="goBack()" class="p-button-raised p-button-danger" label="Cancel"/>
           </div>

           <div class="p-field p-col-12 p-md-1">
            <Button class="p-button-raised p-button-secondary" label="Print" icon="pi pi-print"/>
           </div>
           <div class="p-field p-col-12 p-md-2">
            <Button class="p-button-raised p-button-secondary" label="Generate PDF" icon="pi pi-download"/>
          </div>
        </div>
      </div>

  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import supplierDialog from '../accountDialog/SupplierAccountDialog'
import wearhouseDialog from '../warehouseDialog/warehouseDialog'
import itemDialog from '../itemDialog/itemMasterDialog'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
export default {
  name: 'purchaseChallan',
  props: ['purchaseChallan'],
  data() {
    return {
      name: '',
      warehouseId: '',
      accountMasterId: '',
      items: '',
      referenceNumber: '',
      quantity: 0,
      challanMessage: '',
      rate: 0,
      inventoryInOutDetailList: [],
      inventoryInOutDetailDeleteList: [],
      purchaseSalesDate: new Date().toISOString().slice(0, 10),
      editing: false,
      editDto: false,
      index: null,
      challanNo: null,
      inventoryHeaderId: null,
      loading: false,
      id: null,
      totalQty: '',
      total: 0,
      filteredItems: null,
      englishDateEnabled: true,
      narration: '',
      orderId: null,
      orderIdList: [],
      setWarehouseData: false
    }
  },
  computed: {
    totalAmount() {
      if (this.quantity > 0 && this.rate > 0) {
        let totalAmt = 0
        totalAmt = parseFloat(this.quantity) * parseFloat(this.rate).toFixed(2)
        if (isNaN(totalAmt)) {
          totalAmt = 0
        }
        this.total = totalAmt.toFixed(2)
        return totalAmt
      }
    },
    findRate() {
      if (this.rate === 0) {
        if (this.total > 0 && this.quantity > 0) {
          let rate = 0
          rate = parseFloat(this.total) / parseFloat(this.quantity).toFixed(2)
          if (isNaN(rate)) {
            rate = 0
          }
          this.rate = rate
          return rate
        }
      }
    },
    setRateFromItem() {
      if (!this.editDto) {
        let rate = 0
        this.rate = this.items.purchaseRate
        return rate
      }
    },
    subTotal() {
      let subTotal = 0
      this.taxable = 0
      this.tax = 0
      this.nonTaxable = 0
      this.totalQty = 0
      for (let i = 0; i < this.inventoryInOutDetailList.length; i++) {
        subTotal += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity))
        this.itemSelected = this.inventoryInOutDetailList[i].itemMaster
        this.totalQty += parseFloat(this.inventoryInOutDetailList[i].quantity)
      }
      return subTotal
    },
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    },
    supplierAndCustomerList() {
      return this.$store.state.accountMaster.supplierAndCustomerList
    },
    itemMasterListByItemType() {
      return this.$store.state.fixedAssests.fixedAssetsItemMasterList
    },
    totalBillAmount() {
      let totalBillAmount = 0
      for (let i = 0; i < this.inventoryInOutDetailList.length; i++) {
        totalBillAmount += parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity)
      }
      return totalBillAmount
    }
  },
  mounted() {
    this.orderIdLists()
    this.warehouseList()
    this.supplierCustomerList()
    this.itemMasterListByItemTypes()
    this.maxPurchaseChallanNo()
    if (this.purchaseChallan !== undefined) {
      this.editPurchaseChallan()
    }
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.purchaseChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.setWarehouse()
  },
  methods: {
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    async supplierCustomerList() {
      await this.$store.dispatch('loadsupplierAndCustomerList')
    },
    async itemMasterListByItemTypes() {
      await this.$store.dispatch('loadFixedAssetsItemMasterList')
    },
    async orderIdLists() {
      let response = await this.$store.dispatch('loadOrderIdList')
      this.orderIdList = response.data.data
    },
    async maxPurchaseChallanNo() {
      let response = await this.$store.dispatch('fixedAssetsMaxPurchaseChallanNumber')
      if (this.purchaseChallan === undefined) {
        this.challanNo = response.data.data
        this.challanMessage = response.data.message
        this.narration = response.data.message + '- ' + response.data.data
      } else {
        this.challanNo = this.purchaseChallan.challanNo
        this.challanMessage = this.purchaseChallan.remarks
      }
    },
    addItemToDTO() {
      let item = {
        itemId: this.items.id,
        itemMaster: this.items,
        quantity: this.quantity,
        rate: this.rate,
        id: this.id
      }
      if (this.warehouseId === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select store!', life: 10000})
        return
      }
      if (this.accountMasterId === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select vendor!', life: 10000})
        return
      }
      if (this.items.id === undefined) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Invalid item!', life: 10000})
        return
      }
      if (this.items === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one item!', life: 10000})
        return
      } else if (this.quantity <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Quantity must be greater than 0!', life: 10000})
        return
      } else if (this.rate <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Rate must be greater than 0!', life: 10000})
        return
      } else {
        if (!this.editDto) {
          this.inventoryInOutDetailList.push({...item})
        } else {
          this.inventoryInOutDetailList.splice(this.index, 1, {...item})
        }
      }
      this.itemDTOreset()
      this.focusInput()
    },
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouseId = this.$store.state.warehouseData
      } else if (this.warehouseLists.length === 1) {
        this.warehouseId = this.warehouseLists[0]
      }
    },
    async savePurchaseChallan() {
      if (this.purchaseSalesDate === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select Purchase Date!', life: 10000})
        return
      }
      let response = ''
      let purchaseChallan = {
        challanNo: this.challanNo,
        warehouseId: this.warehouseId.id,
        accountMasterId: this.accountMasterId.id,
        referenceNumber: this.referenceNumber,
        fiscalYearId: this.$store.state.fyId,
        totalBillAmount: this.totalBillAmount,
        remarks: this.narration,
        purchaseSalesDate: this.purchaseSalesDate,
        inventoryHeaderId: this.inventoryHeaderId,
        inventoryInOutDetailList: this.inventoryInOutDetailList,
        inventoryInOutDetailDeleteList: this.inventoryInOutDetailDeleteList
      }
      if (purchaseChallan.inventoryInOutDetailList.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one item!', life: 10000})
        return
      }
      if (!this.editing) {
        this.loading = true
        response = await this.$store.dispatch('addFixedAssetspurchaseChallan', purchaseChallan)
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('updateFixedAssetsPurchaseChallan', purchaseChallan)
        this.loading = false
        this.$router.back()
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.status, life: 10000})
        await this.maxPurchaseChallanNo()
        this.reset()
        this.focusAfterSave
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.status, life: 10000})
      }
    },
    editFromDto(data, index) {
      this.itemDTOreset()
      this.editDto = true
      this.rate = data.rate
      this.quantity = data.quantity
      this.total = (parseFloat(data.rate) * parseFloat(data.quantity)).toFixed(2)
      this.items = data.itemMaster
      if (data.id !== undefined) {
        this.id = data.id
      }
      this.index = index
    },
    set_data_warehouse(data) {
      this.warehouseId = data
      this.warehouseList()
    },
    set_data_item(data) {
      this.items = data
      this.itemMasterListByItemTypes()
    },
    set_supplier_master(data) {
      this.supplierCustomerList()
      this.accountMasterId = data
    },
    editPurchaseChallan() {
      this.editing = true
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.purchaseSalesDate = this.purchaseChallan.purchaseSalesDateNepali
      } else {
        this.purchaseSalesDate = this.purchaseChallan.purchaseDate
      }
      this.inventoryHeaderId = this.purchaseChallan.id
      this.narration = this.purchaseChallan.remarks
      this.referenceNumber = this.purchaseChallan.referenceNumber
      this.warehouseId = this.purchaseChallan.warehouse
      this.accountMasterId = this.purchaseChallan.accountMaster
      this.inventoryInOutDetailList = this.purchaseChallan.inventoryInOutDetailList
    },
    deleteItemFromDTO(data, id) {
      if (this.editing && data.id !== null) {
        this.inventoryInOutDetailDeleteList.push({...data})
      }
      this.inventoryInOutDetailList.splice(id, 1)
    },
    itemDTOreset() {
      this.items = ''
      this.rate = 0
      this.quantity = 0
      this.total = 0
      this.editDto = false
      this.id = null
    },
    reset() {
      this.itemDTOreset()
      this.warehouseId = ''
      this.accountMasterId = ''
      this.referenceNumber = ''
      this.inventoryInOutDetailList = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
      }
      this.orderId = null
    },
    setNepaliDate() {
      if (this.purchaseChallan === undefined) {
        this.purchaseSalesDate = this.$store.getters.nepaliNewDate
      }
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    nepaliDate() {
      $('#purchaseSalesDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.purchaseSalesDate = $('#purchaseSalesDate').val()
        }
      })
    },
    searchItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredItems = [...this.itemMasterListByItemType]
        } else {
          this.filteredItems = this.itemMasterListByItemType.filter((item) => {
            return item.name.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    },
    focusInput() {
      this.$refs.itm.focus()
    },
    focusAfterSave() {
      this.$refs.tran.focus()
    },
    goBack() {
      if (this.inventoryInOutDetailDeleteList.length > 0) {
        this.purchaseChallan.inventoryInOutDetailList = this.inventoryInOutDetailDeleteList
      }
      this.$router.back()
    },
    setEnglishDate() {
      this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    async loadOrderDataWithOrderId(order) {
      let response = await this.$store.dispatch('loadDataWithFixedAssetesOrderId', order)
      let responseValue = response.data.data
      if (responseValue.length > 0) {
        responseValue.forEach(data => {
          if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
            this.purchaseSalesDate = data.purchaseSalesDateNepali
          } else {
            this.purchaseSalesDate = data.purchaseDate
          }
          // this.inventoryHeaderId = response.id
          // this.narration = data.remarks
          this.referenceNumber = data.referenceNumber
          this.warehouseId = data.warehouse
          this.accountMasterId = data.accountMaster
          this.inventoryInOutDetailList = data.inventoryInOutDetailList
        })
      }
    }
  },
  components: {
    Dropdown,
    DatePicker,
    AutoComplete,
    InputNumber,
    InputMask,
    supplierDialog,
    wearhouseDialog,
    itemDialog,
    InputText,
    Button,
    Textarea
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">
</style>



// WEBPACK FOOTER //
// fixedAssetsPurchaseChallan.vue?4b4b01e2